module.exports = __webpack_public_path__ + "img/chengyun33.9b8bbb4c.png";